var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.title,
        "close-on-click-modal": false,
        width: "700px",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            "status-icon": "",
            "label-width": "120px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.inputFormSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "角色名称",
                        prop: "name",
                        rules: [
                          {
                            required: true,
                            message: "角色名称不能为空",
                            trigger: "blur",
                          },
                          { validator: _vm.validateName, trigger: "blur" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "角色名称", maxlength: "50" },
                        model: {
                          value: _vm.inputForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "name", $$v)
                          },
                          expression: "inputForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "英文名称",
                        prop: "enName",
                        rules: [
                          {
                            required: true,
                            message: "角色英文名称不能为空",
                            trigger: "blur",
                          },
                          { validator: _vm.validateEnName, trigger: "blur" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "角色英文名称" },
                        model: {
                          value: _vm.inputForm.enName,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "enName", $$v)
                          },
                          expression: "inputForm.enName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否系统数据",
                        prop: "sysData",
                        rules: [
                          {
                            required: true,
                            message: "是否系统数据不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.sysData,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "sysData", $$v)
                            },
                            expression: "inputForm.sysData",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("yes_no"),
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                      _c("div", { staticClass: "help-block" }, [
                        _vm._v("“是”代表此数据只有超级管理员能进行修改"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否可用",
                        prop: "useable",
                        rules: [
                          {
                            required: true,
                            message: "是否可用不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.useable,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "useable", $$v)
                            },
                            expression: "inputForm.useable",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("yes_no"),
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                      _c("div", { staticClass: "help-block" }, [
                        _vm._v("“是”代表此数据可用，“否”则表示此数据不可用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remarks" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", placeholder: "备注" },
                        model: {
                          value: _vm.inputForm.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "remarks", $$v)
                          },
                          expression: "inputForm.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "noMoreClick", rawName: "v-noMoreClick" }],
              attrs: {
                size: "small",
                type: "primary",
                icon: "el-icon-circle-check",
              },
              on: {
                click: function ($event) {
                  return _vm.inputFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }